import GetHeroIcon from "../../utils/getHeroIcon";

interface InfoComponent {
  textSize: "xs" | "sm" | "base" | "xl" | "2xl";
  fontWeight?:
    | "font-extralight"
    | "font-normal"
    | "font-medium"
    | "font-semibold"
    | "font-bold";
  infoIconName?: string;
  warningIconName?: string;
  successIconName?: string;
  iconSize: number;
  iconVariant: "outline" | "solid";
  text: any;
  iconPosition: "start" | "end" | "center";
  backgroundColor?: "bg-bkg" | "bg-secondary-bg" | "bg-profile-bkg";
  bottomMargin?: boolean;
  messageType?: "info" | "warning" | "primary";
  iconColor?: string;
}

export const InfoComponent = ({
  textSize,
  fontWeight = "font-extralight",
  infoIconName = "InformationCircleIcon",
  warningIconName = "ExclamationTriangleIcon",
  successIconName = "InformationCircleIcon",
  iconSize,
  text,
  iconVariant,
  iconPosition,
  backgroundColor = "bg-secondary-bg",
  bottomMargin = false,
  messageType = "info",
  iconColor
}: InfoComponent) => {
  return (
    <>
      {messageType === "info" && (
        <div
          className={`text-${textSize} border-l-4 border-blue-400 text-wrap ${fontWeight} ${
            bottomMargin ? "mb-6" : ""
          } bg-blue-50 dark:${backgroundColor} dark:border-profile-bkg dark:text-blue-400 text-blue-700 p-2 flex items-${iconPosition} gap-x-2 rounded-md dark:border`}
        >
          <GetHeroIcon
            name={infoIconName}
            variant={iconVariant}
            className={`w-${iconSize} h-${iconSize} ${
              iconColor ? `text-${iconColor}` : ""
            }`}
          />
          {text}
        </div>
      )}

      {messageType === "warning" && (
        <div
          className={`text-${textSize} border-l-4 border-amber-300 text-wrap ${fontWeight} ${
            bottomMargin ? "mb-6" : ""
          } bg-amber-50 dark:bg-amber-950/40 dark:border-amber-700 text-amber-800 dark:text-amber-200 p-2 flex items-${iconPosition} gap-x-2 rounded-md dark:border-none`}
        >
          <GetHeroIcon
            name={warningIconName}
            variant={iconVariant}
            className={`w-${iconSize} h-${iconSize} text-amber-500`}
          />
          {text}
        </div>
      )}

      {messageType === "primary" && (
        <div
          className={`text-${textSize} text-wrap ${fontWeight} ${
            bottomMargin ? "mb-6" : ""
          } bg-primary-light dark:${backgroundColor} dark:border-profile-bkg dark:text-primary text-primary p-4 flex items-${iconPosition} gap-x-2 rounded-md`}
        >
          <GetHeroIcon
            name={successIconName}
            variant={iconVariant}
            className={`w-${iconSize} h-${iconSize} ${
              iconColor ? `text-${iconColor}` : ""
            }`}
          />
          {text}
        </div>
      )}
    </>
  );
};
